export default __webpack_public_path__ + "static/media/kpi-testing.35d7bc3d.jpg";